import axios from 'axios'
import {ID, QUERIES} from '../../../../../../_metronic/helpers'
import {ExamOnlineExam, ExamToQuestion} from './_models'

const API_URL = process.env.REACT_APP_API_V2_URL + '/' + QUERIES.EXAM_ONLINE_EXAMS_LIST
const API_URL2 = process.env.REACT_APP_API_V2_URL + '/' + QUERIES.EXAM_QUESTION_ANSWERS_LIST

const createExamOnlineExam = (
  examOnlineExam: ExamOnlineExam
): Promise<ExamOnlineExam | undefined> => axios.post(API_URL, examOnlineExam)

const exportOnlineExamResults = (
  examOnlineExam: ExamOnlineExam
): Promise<ExamOnlineExam | undefined> => axios.post(API_URL + '/marks', examOnlineExam)

export const createExamQuestionAnswer = (examQuestionAnswer: any): Promise<any | undefined> =>
  axios.post(API_URL2, examQuestionAnswer)

const updateExamOnlineExam = (
  examOnlineExam: ExamOnlineExam
): Promise<ExamOnlineExam | undefined> =>
  axios.patch(`${API_URL}/${examOnlineExam.id}`, examOnlineExam)

const deleteExamOnlineExam = (examOnlineExamId: ID): Promise<void> =>
  axios.delete(`${API_URL}/${examOnlineExamId}`)

const createExamToQuestion = (
  examToQuestion: ExamToQuestion
): Promise<ExamToQuestion | undefined> =>
  axios.post(
    process.env.REACT_APP_API_V2_URL + '/' + QUERIES.EXAM_TO_QUESTIONS_LIST,
    examToQuestion
  )

export {
  deleteExamOnlineExam,
  createExamOnlineExam,
  updateExamOnlineExam,
  createExamToQuestion,
  exportOnlineExamResults,
}
